/** Latest token callback wins. Older profile and agreement results are discarded. */
export function authResultIsCurrent({ generation, activeGeneration, uid, activeUid }) {
  return generation === activeGeneration && (uid || '') === (activeUid || '');
}
